import type Phaser from "phaser";
import { worldTextStyle } from "../text.js";

/** A small floating text panel used for interaction prompts. */
export class InteractionPrompt {
  private readonly text: Phaser.GameObjects.Text;

  constructor(scene: Phaser.Scene) {
    this.text = scene.add
      .text(
        0,
        0,
        "",
        worldTextStyle(scene, {
          fontSize: "8px",
          color: "#12141c",
          backgroundColor: "#ffe08a",
          padding: { x: 3, y: 2 },
        }),
      )
      .setOrigin(0.5, 1)
      .setDepth(200_000)
      .setVisible(false);
  }

  set(text: string, x: number, y: number): void {
    if (!text) {
      this.text.setVisible(false);
      return;
    }
    this.text.setText(text).setPosition(Math.round(x), Math.round(y)).setVisible(true);
  }

  destroy(): void {
    this.text.destroy();
  }
}
